"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscribable = void 0;
var Subscribable = /** @class */ (function () {
    function Subscribable() {
        var _this = this;
        this._subscriptions = new Set();
        this._notifyFunc = function (value) { return _this._subscriptions.forEach(function (s) { return s(value); }); };
    }
    Subscribable.prototype.subscribe = function (handler) {
        var _this = this;
        this._subscriptions.add(handler);
        return {
            dispose: function () {
                if (_this._subscriptions.has(handler)) {
                    _this._subscriptions.delete(handler);
                }
            },
        };
    };
    Subscribable.prototype.notifySubscribers = function (value) {
        this._notifyFunc(value);
    };
    Subscribable.prototype.dispose = function () {
        this._subscriptions.clear();
    };
    return Subscribable;
}());
exports.Subscribable = Subscribable;
//# sourceMappingURL=Subscribable.js.map